export const DEFAULT_TERMS = `
1. Price indicated in our offer is for AWL Agri Business Ltd, Hazira, Surat, Gujarat.<br/>
2. Offer Validity: 7 days.<br/>
3. Packaging: Loose Packing.<br/>
4. Payment Terms: Within 30 days after material received.<br/>
5. Delivery Time: 2 weeks after PO.<br/><br/>

Trust you shall find the above offer in order. However, we shall be glad to answer any clarification that you may have in this regard.<br/><br/>

With Warm Regards,<br/>
BK Enterprise<br/>
Surat, Gujarat.
`;

export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ size: [] }],

    ["bold", "italic", "underline", "strike"],

    [{ color: [] }, { background: [] }],

    [{ script: "sub" }, { script: "super" }],

    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],

    [{ align: [] }],

    ["blockquote", "code-block"],
    ["link"],

    ["clean"],
  ],
};

export const quillFormats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "align",
  "blockquote",
  "code-block",
  "link",
];
